/* @flow */

import type { IsRamp, Point, Tools } from './Common';
import { GridHeight, SurfaceLineWidth } from './Common';
import Surface from './Surface';

export default class Ramp extends Surface implements IsRamp {
  radiansStep = 0.01;
  minRadians = 0.3;
  maxRadians = 1.2;
  bottomPoint: Point;

  constructor(topCenter: Point, radians: number, hypotenuse: number) {
    super(topCenter, radians, hypotenuse);
    this.setCenterPositionFromTop(topCenter);
  }

  setCenterPositionFromTop(topCenter: Point) {
    const { radians } = this;
    const { width, height } = this.getSlope();
    const dx = radians > 0 ? -1 : 1;
    const centerPosition = {
      x: topCenter.x + (dx * width) / 2,
      y: topCenter.y - Math.abs(height / 2),
    };
    this.setCenterPosition(centerPosition);
  }
  calculatePoints() {
    super.calculatePoints();
    const { radians, leftPoint, rightPoint } = this;
    this.bottomPoint = {
      x: radians > 0 ? rightPoint.x : leftPoint.x,
      y: Math.min(leftPoint.y, rightPoint.y),
    };
  }

  flatten() {
    const { radiansStep, minRadians } = this;
    if (this.radians > 0) {
      this.radians = Math.max(minRadians, this.radians - radiansStep);
    } else {
      this.radians = Math.min(0 - minRadians, this.radians + radiansStep);
    }
    this.calculatePoints();
  }
  sharpen() {
    const { radiansStep, maxRadians } = this;
    if (this.radians > 0) {
      this.radians = Math.min(maxRadians, this.radians + radiansStep);
    } else {
      this.radians = Math.max(0 - maxRadians, this.radians - radiansStep);
    }
    this.calculatePoints();
  }

  contains(p: Point) {
    // todo rough solution for catching bullets inside the ramp, needs work
    const { slope } = this.getSlope();
    const { leftPoint, rightPoint, bottomPoint } = this;
    const dx = p.x - leftPoint.x;
    const plotY = leftPoint.y + slope * dx;
    const bottom = bottomPoint.y;
    const contains = leftPoint.x <= p.x && p.x <= rightPoint.x && bottom <= p.y && p.y <= plotY;
    return contains
      ? {
          x: p.x,
          y: plotY,
        }
      : null;
  }

  draw(tools: Tools, colorEdge: string, colorFill: string) {
    const { leftPoint, rightPoint, bottomPoint } = this;

    tools.ctx.fillStyle = colorFill;
    tools.ctx.beginPath();
    tools.ctx.moveTo(rightPoint.x, GridHeight - rightPoint.y);
    tools.ctx.lineTo(bottomPoint.x, GridHeight - bottomPoint.y);
    tools.ctx.lineTo(leftPoint.x, GridHeight - leftPoint.y);
    tools.ctx.fill();

    tools.ctx.lineWidth = SurfaceLineWidth;
    tools.ctx.strokeStyle = colorEdge;
    tools.ctx.beginPath();
    tools.ctx.moveTo(leftPoint.x, GridHeight - leftPoint.y);
    tools.ctx.lineTo(rightPoint.x, GridHeight - rightPoint.y);
    tools.ctx.stroke();
  }
}



// WEBPACK FOOTER //
// ./src/Ramp.js